// Constantes do ciclo de vida do imóvel compartilhadas entre UI e rotas.
// (Espelham os enums PG ImovelArchiveReason/ImovelEventoTipo do schema.)

export const ARCHIVE_REASONS = [
  'VENDIDO_POR_NOS',
  'VENDIDO_TERCEIROS',
  'RETIRADO_DA_VENDA',
  'ALUGADO',
  'DUPLICADO',
  'SAIU_DA_CARTEIRA_PARCEIRO',
  'OUTRO',
] as const;

export type ArchiveReason = (typeof ARCHIVE_REASONS)[number];

export const ARCHIVE_REASON_LABELS: Record<ArchiveReason, string> = {
  VENDIDO_POR_NOS: 'Vendido por nós',
  VENDIDO_TERCEIROS: 'Vendido por terceiros',
  RETIRADO_DA_VENDA: 'Retirado da venda',
  ALUGADO: 'Alugado',
  DUPLICADO: 'Cadastro duplicado',
  SAIU_DA_CARTEIRA_PARCEIRO: 'Saiu da carteira do parceiro',
  OUTRO: 'Outro',
};

/** Motivos oferecidos no modal do CRUD (o do sync é aplicado pelo sistema). */
export const ARCHIVE_REASONS_CRUD: ArchiveReason[] = [
  'VENDIDO_POR_NOS',
  'VENDIDO_TERCEIROS',
  'RETIRADO_DA_VENDA',
  'ALUGADO',
  'DUPLICADO',
  'OUTRO',
];

export const VENDA_REASONS: ArchiveReason[] = ['VENDIDO_POR_NOS', 'VENDIDO_TERCEIROS'];

export const EVENTO_TIPO_LABELS: Record<string, string> = {
  CRIADO: 'Criado',
  ATUALIZADO: 'Atualizado',
  ARQUIVADO: 'Arquivado',
  REATIVADO: 'Reativado',
  DESATIVADO: 'Desativado',
  IMAGENS_EXPURGADAS: 'Fotos removidas',
  VISITADO: 'Visitado',
};
